import styled from 'styled-components'

const GridArea = styled.div`
grid-area: ${props => props.gridArea}
`;

export default GridArea